import { z } from 'zod';
// Tiny leaf module for the BrandChannelKind enum so both
// brand-channel.ts (which carries takeoverProposal on the DTO) and
// channel-takeover-proposal.ts (which uses BrandChannelKind on the
// proposal envelope) can import the schema without forming a
// circular import. Module-level execution order matters here — if
// brand-channel.ts imports channel-takeover-proposal.ts at the top
// and channel-takeover-proposal.ts imports BrandChannelKind from
// brand-channel.ts, Node hits a partially-evaluated module and
// throws "Cannot access 'brandChannelKindSchema' before
// initialization." Extracting the enum to its own file breaks the
// cycle without changing any consumer's import surface — both files
// re-export it.
export const brandChannelKindSchema = z.enum(['instagram', 'linkedin', 'tiktok', 'youtube']);
//# sourceMappingURL=brand-channel-kind.js.map